import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../css/LoginPage.css";
import authService from "../../api/authClient";

const VerifyEmail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const verifyEmail = async () => {
      // Extract token from URL query parameters
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("token");

      if (!token) {
        setErrorMessage("Invalid or missing verification token.");
        setIsLoading(false);
        return;
      }

      try {
        await authService.verifyEmail(token);
        setIsVerified(true);
      } catch (error) {
        console.error("Email verification error:", error);
        setErrorMessage(
          error.response?.data?.detail ||
            "Email verification failed. The link may have expired or already been used."
        );
      } finally {
        setIsLoading(false);
      }
    };

    verifyEmail();
  }, [location.search]);

  const handleLogin = () => {
    navigate("/login");
  };

  const handleResendVerification = () => {
    navigate("/login?resend=true");
  };

  if (isLoading) {
    return (
      <div className="login-container">
        <div className="login-form-section" style={{ width: "100%" }}>
          <div className="form-container">
            <h1 className="form-title">Verifying Email</h1>
            <p className="form-subtitle">
              Please wait while we verify your email...
            </p>
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form-section" style={{ width: "100%" }}>
        <div className="logo-container">
          <div className="logo-placeholder"></div>
          <span className="logo-text">SkillMatchAI</span>
        </div>

        <div className="form-container">
          {isVerified ? (
            <>
              <h1 className="form-title">Email Verified!</h1>
              <p className="form-subtitle">
                Your email has been successfully verified. You can now log in to
                your account.
              </p>
              <div className="success-message">
                Email verification successful!
              </div>
              <button className="signin-button" onClick={handleLogin}>
                Go to Login
              </button>
            </>
          ) : (
            <>
              <h1 className="form-title">Verification Failed</h1>
              <p className="form-subtitle">
                We couldn't verify your email address.
              </p>
              <div className="error-message">{errorMessage}</div>
              <div className="verification-options">
                <button
                  className="signin-button"
                  onClick={handleResendVerification}
                >
                  Resend Verification Email
                </button>
                <button className="secondary-button" onClick={handleLogin}>
                  Back to Login
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
